import React from "react";
import { useSelector } from "react-redux";
import { IAirplane } from "../../../common/types";
import { Form, Select } from "../../atoms";
import { UserSelectedFieldWrapper } from "./Fields.style";

interface IAirplaneSelectedFieldProps {
  bordered?: boolean;
  name: string | Array<string | number>;
  label?: string;
  rules?: any[];
  placeholder?: string;
  style?: any;
  mode?: "multiple" | "tags";
  maxTagCount?: number;
  initialValue?: any;
  getAirplane?: () => IAirplane;
  onChange?: (value: any) => void;
}
export const AirplaneSelectedField: React.FC<IAirplaneSelectedFieldProps> = ({
  name,
  label,
  mode,
  rules,
  getAirplane,
  onChange,
  bordered = true,
  style,
  placeholder,
  maxTagCount,
  initialValue,
}) => {
  const { airplanes } = useSelector((state: any) => state.airplanes);

  return (
    <UserSelectedFieldWrapper>
      <Form.Item
        label={label}
        name={name}
        rules={rules}
        initialValue={initialValue}
      >
        <Select
          showSearch
          bordered={bordered}
          style={style}
          placeholder={placeholder || label}
          optionFilterProp="label"
          filterOption={(input, option: any) =>
            option.search.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          options={airplanes.map((airplane: IAirplane) => ({
            value: airplane.id,
            label: airplane.name,
            search: `${airplane?.name || ""}`,
          }))}
          mode={mode}
          maxTagCount={maxTagCount}
          onChange={onChange}
        ></Select>
      </Form.Item>
    </UserSelectedFieldWrapper>
  );
};

export default AirplaneSelectedField;
